import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { CardContextObject } from './context/CardContext';
import { CardButtonFooter, CardFooterContainer } from './styles/card-footer.styled';
const CardFooter = ({ children, reference, button = null, index }) => {
    const { collapsed, useBackground, mode, editable, dataTest, useRedesign } = useContext(CardContextObject);
    const showFooterButtonOnNonEditableNonCollapsedState = button && !editable && !collapsed;
    if (mode !== 'read') {
        return null;
    }
    return (_jsxs(_Fragment, { children: [children && (_jsx(CardFooterContainer, { className: "PONCHO-card__footer", "$useBackground": useBackground, "$useRedesign": useRedesign, id: reference, "data-test": `${dataTest}-footer${index !== undefined ? `-${index}` : ''}`, children: children })), showFooterButtonOnNonEditableNonCollapsedState && (_jsx(CardButtonFooter, { "$useRedesign": useRedesign, className: "PONCHO-card__button-footer", "data-test": `${dataTest}-footer-button`, children: button }))] }));
};
CardFooter.CARD_ELEMENT = 'CARD_FOOTER';
export default CardFooter;
